<template>
    <div class="w-full h-full flex flex-col min-h-0">
        <div
            class="relative flex flex-col flex-1 min-h-0 w-full"
            v-show="shouldShowConnectWidget"
        >
            <button
                type="button"
                @click.prevent="$emit('close')"
                class="absolute top-2 right-2 z-10 flex items-center justify-center w-8 h-8 rounded-full bg-white dark:bg-slate-800 shadow border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                title="Close"
            >
                <Icon icon="close" class="w-4 h-4" />
            </button>
            <div
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-3xl text-slate-500 dark:text-slate-400"
                v-if="loadingConnectWidget"
            >
                <i class="fas fa-spinner-third fa-spin"></i>
            </div>
            <!-- The MX widget SDK owns this element and clears it, so Vue must
                 render nothing inside it: a wiped child left Vue patching a
                 detached node (MY10X-1HZ insertBefore / nextSibling on null). -->
            <div
                id="connect-widget"
                :key="`connect-widget-${connectStep}-${completedConnect}`"
                class="flex justify-center items-center flex-1 min-h-0 overflow-y-auto w-full"
                ref="connectWidgetContainer"
            ></div>
        </div>
        <div v-if="completedConnect && !finshedSyncAccount">
            <div class="modal-body">
                <div class="text-center mb-5">
                    <i
                        class="far fa-spinner-third text-7xl text-orange fa-spin"
                    ></i>
                </div>

                <h3
                    class="modal-title mb-5 text-center"
                    id="add-card-modal-title"
                >
                    Syncing Your {{ chosenBank }} Account
                </h3>
                <p class="mb-3 text-center">
                    Hang tight!
                    <br />
                    We need about a minute or so to finish
                    syncing your
                    {{ chosenBank }} account.
                </p>
            </div>
        </div>
        <div
            v-if="
                finshedSyncAccount &&
                !showAccountSyncDelayMessage
            "
        ></div>
        <div v-if="showAccountSyncDelayMessage">
            <div class="modal-body">
                <div
                    class="text-center mb-4 mx-auto flex justify-center items-center rounded-full bg-slate-100 dark:bg-slate-700 w-14 h-14"
                >
                    <i
                        class="fal fa-info-circle text-2xl"
                    ></i>
                </div>

                <div class="text-center mb-10 px-4">
                    <h3 class="mb-4 text-2xl font-bold">
                        {{ chosenBank }} Account Sync in
                        Progress
                    </h3>
                    <p class="text-base mb-5">
                        Thanks for connecting your
                        {{ chosenBank }} account to My10x.
                        The accounts are still being synced
                        and is taking longer than expected.
                    </p>
                    <p class="text-base mb-5">
                        We will keep checking for the new
                        accounts every few minutes within
                        the next 12 hours and notify you
                        when it is complete.
                    </p>
                    <p class="text-base mb-5">
                        You may close this window and
                        continue using My10x, and we'll let
                        you know when your accounts have
                        finished syncing in the background.
                    </p>
                </div>
            </div>
            <div
                class="modal-footer justify-start bg-slate-50 dark:bg-slate-800"
            >
                <button
                    class="btn-base btn-dark w-48"
                    @click="$emit('finishAddingCard')"
                    id="hs-wallet-connect-finished"
                >
                    Finished
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

defineProps({
    connectStep: { type: Number, required: true },
    completedConnect: { type: Boolean, default: false },
    finshedSyncAccount: { type: Boolean, default: false },
    showAccountSyncDelayMessage: { type: Boolean, default: false },
    shouldShowConnectWidget: { type: Boolean, default: false },
    loadingConnectWidget: { type: Boolean, default: false },
    chosenBank: { type: String, default: '' },
});

defineEmits(['close', 'finishAddingCard']);

const connectWidgetContainer = ref(null);

defineExpose({ connectWidgetContainer });
</script>
